import type { Notification, NotificationApp } from "./types";

const LIBRARY_BORROW_REMINDER_TYPES = [
  "BorrowDueReminderNotificationEvent",
  "BorrowDueReminderForLibrarianNotificationEvent",
];

function getBaseUrlByLabel(label: string): string {
  const normalizedLabel = (label || "").toLowerCase().trim();

  const baseUrlMap: Record<string, string> = {
    "job order": import.meta.env.VITE_WORKCHESTRA_BASE_URL || "",
    eform: import.meta.env.VITE_WORKCHESTRA_BASE_URL || "",
    crr:
      import.meta.env.VITE_ECSR_BASE_URL ||
      import.meta.env.VITE_CSR_BASE_URL ||
      "",
    "cap master": import.meta.env.VITE_CAP_MASTER_BASE_URL || "",
  };

  return baseUrlMap[normalizedLabel] || "";
}

function getBaseUrlByApp(appName: string, apps: NotificationApp[]): string {
  const normalizedAppName = (appName || "").toLowerCase().trim();

  const appBaseUrlMap: Record<string, string> = {
    library: import.meta.env.VITE_LIBRARY_BASE_URL || "",
    "cap master": import.meta.env.VITE_CAP_MASTER_BASE_URL || "",
    ecsr:
      import.meta.env.VITE_ECSR_BASE_URL ||
      import.meta.env.VITE_CSR_BASE_URL ||
      "",
    crr:
      import.meta.env.VITE_ECSR_BASE_URL ||
      import.meta.env.VITE_CSR_BASE_URL ||
      "",
    workchestra: import.meta.env.VITE_WORKCHESTRA_BASE_URL || "",
    // AeroTrak (My Profile). AeroStaff has its own host and resolves through `apps` (WOR-2546).
    aerotrak: import.meta.env.VITE_AEROTRAK_BASE_URL || "",
    tool: import.meta.env.VITE_TOOL_BASE_URL || "",
    audit: import.meta.env.VITE_AUDIT_BASE_URL || "",
  };

  if (appBaseUrlMap[normalizedAppName]) {
    return appBaseUrlMap[normalizedAppName];
  }

  const appUrl = apps.find(
    (app) => (app.name || "").toLowerCase().trim() === normalizedAppName,
  )?.url;

  return appUrl || "";
}

// Origin the notification's actionLink is appended to.
export function resolveNotificationBaseUrl(
  notification: Notification,
  apps: NotificationApp[],
): string {
  const baseUrlByLabel = getBaseUrlByLabel(notification.label);
  const baseUrlByApp = getBaseUrlByApp(notification.app, apps);
  const fallbackBaseUrl = import.meta.env.VITE_WORKCHESTRA_BASE_URL || "";

  // For Library borrow reminder templates, resolve by app first.
  if (
    LIBRARY_BORROW_REMINDER_TYPES.includes(notification.notificationType ?? "")
  ) {
    return baseUrlByApp || baseUrlByLabel || fallbackBaseUrl;
  }

  return baseUrlByLabel || baseUrlByApp || fallbackBaseUrl;
}
